export default __webpack_public_path__ + "static/media/cloud.8e1e6751.svg";